var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 190,
    viewBox: "0 0 246 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.551 183C169.964 183 209.213 143.699 209.213 95.0493C209.213 46.3993 169.791 7.09836 121.551 7.09836C73.1382 7.09836 33.8892 46.3993 33.8892 95.0493C33.8892 143.699 73.1382 183 121.551 183Z",
    fill: "url(#paint0_linear_953_47966)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.881 9.69533C216.554 9.69533 218.723 7.51378 218.723 4.84756C218.723 2.16402 216.554 0 213.881 0C211.208 0 209.04 2.16402 209.04 4.84756C209.04 7.51378 211.208 9.69533 213.881 9.69533Z",
    fill: "#384252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5576 37.2233C41.2307 37.2233 43.3989 35.0418 43.3989 32.3755C43.3989 29.692 41.2307 27.528 38.5576 27.528C35.8845 27.528 33.7163 29.692 33.7163 32.3755C33.7163 35.0418 35.8845 37.2233 38.5576 37.2233Z",
    fill: "#384252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.991 130.714C13.9568 130.714 17.982 126.68 17.982 121.711C17.982 116.742 13.9568 112.709 8.991 112.709C4.02521 112.709 0 116.742 0 121.711C0 126.68 4.02521 130.714 8.991 130.714Z",
    fill: "#384252"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_953_47966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.082 48.8404V150.711C205.082 153.706 202.596 156.199 199.61 156.199H45.0222C42.0378 156.32 39.5498 153.827 39.5498 150.832V48.8404C39.5498 45.7413 42.0378 43.3693 45.0222 43.3693H199.61C202.719 43.3693 205.082 45.8625 205.082 48.8404Z",
    fill: "#4A5463"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.082 48.8404V56.7006H39.5498V48.8404C39.5498 45.7413 42.0378 43.3693 45.0222 43.3693H199.61C202.719 43.3693 205.082 45.8625 205.082 48.8404Z",
    fill: "#384252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4952 96.1745C102.037 96.1745 104.096 94.1143 104.096 91.5693C104.096 89.0243 102.037 86.9466 99.4952 86.9466C96.9536 86.9466 94.8926 89.0243 94.8926 91.5693C94.8926 94.1143 96.9536 96.1745 99.4952 96.1745Z",
    fill: "#B8C5CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.262 96.1745C147.803 96.1745 149.864 94.1143 149.864 91.5693C149.864 89.0243 147.803 86.9466 145.262 86.9466C142.722 86.9466 140.661 89.0243 140.661 91.5693C140.661 94.1143 142.722 96.1745 145.262 96.1745Z",
    fill: "#B8C5CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.84 126.438H115.415C113.176 126.438 111.31 124.568 111.31 122.318C111.31 120.084 113.176 118.214 115.415 118.214H129.716C131.955 118.214 133.82 120.084 133.82 122.318C133.945 124.568 132.079 126.438 129.84 126.438Z",
    fill: "#B8C5CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8881 52.3376C47.9186 52.3376 48.7538 51.5067 48.7538 50.4679C48.7538 49.4291 47.9186 48.5979 46.8881 48.5979C45.8575 48.5979 45.0225 49.4291 45.0225 50.4679C45.0225 51.5067 45.8575 52.3376 46.8881 52.3376Z",
    fill: "#F9FAFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7318 52.3376C53.7623 52.3376 54.5975 51.5067 54.5975 50.4679C54.5975 49.4291 53.7623 48.5979 52.7318 48.5979C51.7013 48.5979 50.8662 49.4291 50.8662 50.4679C50.8662 51.5067 51.7013 52.3376 52.7318 52.3376Z",
    fill: "#F9FAFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7025 52.3376C59.733 52.3376 60.5682 51.5067 60.5682 50.4679C60.5682 49.4291 59.733 48.5979 58.7025 48.5979C57.672 48.5979 56.8369 49.4291 56.8369 50.4679C56.8369 51.5067 57.672 52.3376 58.7025 52.3376Z",
    fill: "#F9FAFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.367 30.1767C197.124 30.1767 196.128 29.1727 196.128 27.9261V2.89116C196.128 1.64461 197.124 0.657906 198.367 0.657906C199.61 0.657906 200.606 1.64461 200.606 2.89116V27.9261C200.606 29.1727 199.61 30.1767 198.367 30.1767Z",
    fill: "#5D6675"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.525 49.3425C216.525 48.096 217.52 47.109 218.763 47.109H243.761C245.004 47.109 246 48.096 246 49.3425C246 50.5891 245.004 51.5931 243.761 51.5931H218.763C217.52 51.5931 216.525 50.5891 216.525 49.3425Z",
    fill: "#5D6675"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.535 33.1548C213.664 32.2892 213.664 30.8002 214.535 29.9173L232.32 12.2404C233.19 11.3574 234.682 11.3574 235.554 12.2404C236.423 13.1061 236.423 14.595 235.554 15.478L217.893 33.1548C216.897 34.0378 215.405 34.0378 214.535 33.1548Z",
    fill: "#5D6675"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_953_47966",
    x: 17.5498,
    y: 32.3693,
    width: 209.533,
    height: 156.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_953_47966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_953_47966",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_953_47966",
    x1: 123.562,
    y1: -24.7945,
    x2: 121.766,
    y2: 68.4066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAGroup);
export default __webpack_public_path__ + "static/media/select-a-group.2ec767720c099e35c95055aa5a189cbc.svg";
export { ForwardRef as ReactComponent };